import React from 'react';

export function SectionIcon() {
    return <span className="cat-sect-icon">༇</span>;
}
